module.exports = "<div>\n  <h1>{{ $ctrl.name }}</h1>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/product/product.html
// module id = 608
// module chunks = 0